<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Modifiers</h1>
      </b-col>
      <b-col v-if="brandAdmin" class="text-right px-sm-3 px-0">
        <b-button variant="primary" @click="$router.push('modifiers/create')">
          Add Modifier
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="px-sm-3 px-0">
        <b-overlay :show="loading" no-wrap fixed />
        <b-form inline class="mb-2" @submit.prevent="applyFilters">
          <b-form-input
            v-model="queryFilters.search"
            placeholder="Search by name, import key or id"
            title="Search by name, import key or id"
            class="mr-2 mb-2 single-input"
          />
          <custom-search-field
            v-model="queryFilters.brand"
            class="mr-2 mb-2 single-input"
            :placeholder="'Filter by brand'"
            :path-to-search="'brands'"
            :query-params="{
              status: 'active,inactive',
            }"
          />
          <b-button type="submit" variant="primary" class="mb-2"
            >Filter</b-button
          >
        </b-form>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
          @row-clicked="onRowClicked"
        >
          <template #cell(name)="row">
            <router-link :to="`/modifiers/${row.item.id}`">
              {{ row.item.name }}
            </router-link>
          </template>
          <template #cell(brand)="row">
            {{ row.item.brand.name }}
          </template>
          <template #cell(active)="row">
            <template v-if="row.item.active">Active</template>
            <template v-else>Inactive</template>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  name: 'Modifiers',
  mixins: [tableMixin],
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Modifier Group',
          sortable: true,
        },
        {
          key: 'brand',
          label: 'Brand',
          sortable: true,
        },
        {
          key: 'import_key',
          label: 'Import Key',
          sortable: true,
        },
      ],
      data: [],
      rowRouteName: 'modifier',
      loading: false,
      exportAlert: false,
    };
  },
  computed: {
    ...mapGetters('session', ['brandAdmin', 'brandCount', 'hubCount']),
  },
  methods: {
    loadResults() {
      this.setRequestData();
      // Format search params for query
      const searchParams = { ...this.queryFilters };
      searchParams.brand = searchParams.brand ? searchParams.brand.id : null;
      searchParams.with = 'brand';
      searchParams.brandStatus = 'active,inactive';
      searchParams.active = 1;

      return ResourceAPI.getRecords('attributes', searchParams)
        .then((data) => {
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
